import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import { faReact, faAws } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const embeddedStack = [
    "C++",
    "Python",
    "Git",
    "Jenkins",
    "Docker",
    "Linux",
    "Terraform",
    "Wireshark",
    "Virtual Machines",
    "Junit"
];

const fullStack = [
    "React",
    "JavaScript",
    "TypeScript",
    "HTML5",
    "Java",
    "Python",
    "Go",
    "SQL",
    "Supabase"
];

const aiCloud = [
    "AWS",
    "Terraform",
    "Docker",
    "ChatGPT API",
    "Amazon Polly",
    "Python",
    "Jenkins"
];

function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>Skills</h1>
                <div className="skills-grid">

                    {/* 1️⃣ Embedded Systems & DevOps */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faCogs} size="3x" />
                        <h3>Embedded Systems & DevOps</h3>
                        <p>
                            Engineered production-grade firmware and CI/CD automation during two internships at Garmin Canada.
                            Slashed testing times by over 90% by building automated compliance tests and runtime tooling.
                            Eliminated critical build failures by developing a Python script to automate C mock generation.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {embeddedStack.map((label, index) => (
                                <Chip key={index} className="chip" label={label} />
                            ))}
                        </div>
                    </div>

                    {/* 2️⃣ Full Stack Development */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faReact} size="3x" />
                        <h3>Full Stack Development</h3>
                        <p>
                            Architected and deployed full-stack applications, from professional-grade test features at Garmin
                            to serverless AI projects on AWS. Engineered performant backends, optimizing a scheduling service
                            to cut latency by 95% and building automated Python data pipelines for a C++ trading engine.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {fullStack.map((label, index) => (
                                <Chip key={index} className="chip" label={label} />
                            ))}
                        </div>
                    </div>

                    {/* 3️⃣ AI & Cloud Automation */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faAws} size="3x" />
                        <h3>AI & Cloud Automation</h3>
                        <p>
                            Engineered a serverless AI application on AWS, orchestrating generative APIs like ChatGPT and 
                            Amazon Polly to produce dynamic content from user data. Built and managed the system's scalable
                            infrastructure entirely as code using a fully automated Terraform CI/CD pipeline.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {aiCloud.map((label, index) => (
                                <Chip key={index} className="chip" label={label} />
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Expertise;
